<!-- begin:: Setting Section -->
<div class="d-flex align-items-stretch">
  <div class="d-flex align-items-center">
    <div (click)="onOpenSettingDialog()" class="btn btn-icon btn-active-light btn-active-color-primary w-100 px-2 cursor-pointer">
      <!-- begin:: Language / Country  / Currency -->
      @if (country) {
        <div [matTooltip]="infoToolTip">
          <img title="flag" class="h-15px w-20px rounded me-1" [alt]="country?.name" [src]="language?.flag" />
          <span class="fs-7 text-gray-700 fw-semibold d-none d-lg-inline-flex text-hover-primary justify-content-center align-content-center">
            {{ language?.code }} / {{ country?.code }} / {{ currency }} /
            @defer (on immediate) {
              @if (customerType == "1") {
                <!-- Private -->
                <i class="bi bi-person-fill-check fs-3 ms-1"></i>
              } @else {
                <!-- Bussiness -->
                <i class="bi bi-building-fill-check fs-4 ms-1"></i>
              }
            } @placeholder {
              <!-- loading placeholder -->
              <div class="placeholder-glow">
                <i class="bi bi-person-fill-check fs-3 ms-1 placeholder rounded"></i>
              </div>
            } @error {
              <p class="d-none">Failed to component</p>
            }
          </span>
        </div>
      } @else {
        <mat-spinner class="spinner float-end" diameter="15"></mat-spinner>
      }
      <!-- end:: Language / Country  / Currency -->
    </div>
  </div>
</div>
<!-- end:: Setting Section -->
